(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aufbau-apple-iphone18"] && !Shopify.designMode) return;
  try {
    
/*!
Apple Inc.
LICENSE AGREEMENT FOR CHANNEL INTERACTIVE PARTNERS
IMPORTANT: This code, software, and web technologies (the "Apple Software") is 
supplied to you by Apple Inc. (“Apple") to integrate and host on your websites, in your 
capacity as a current, and in good standing, member of the Channel Interactive 
Licensing Program (the “Program”). Use of the Apple Software is governed by and 
subject to the following terms and conditions of this License Agreement for Channel 
Interactive Partners (the “License”) and any relevant legal agreements you entered into 
related to the Program. You hereby agree that the use, installation, modiﬁcation, or 
redistribution of this Apple Software constitutes your acceptance of these terms. If you 
do not agree with these terms, you may not use, install, modify, or redistribute this Apple 
Software.  
 
No rights are granted to you under this License for any purpose other than marketing, 
offering for sale, and selling Apple’s products, services, and technologies on your 
website (the “Limited Purpose”). Subject to the terms of this License, Apple grants to 
you only for so long as you are a current, good-standing member of the Program, a 
personal, non-transferrable, non-exclusive license to use and modify the Apple Software 
solely for the Limited Purpose. Subject to the terms of this License, Apple grants to you 
only for so long as you are current, good standing members of the Program, a personal, 
non-transferrable, non-exclusive limited license to redistribute only the portions of the 
Apple Software necessary to be sent by your servers to your users’ web browser to run 
client-side code (such as JavaScript) as part of the normal operation of your website, 
and solely for the Limited Purpose. You must retain this notice and the following text and 
disclaimers in all such redistributions of the Apple Software, which may be met by the 
inclusion of this notice in comments in JavaScript sent by your website to your users’ 
web browser. Any reverse engineering of Apple Software is prohibited without Apple’s 
prior written approval. Apple may immediately terminate this License if you fail to notify 
third parties of the prohibition to alter, modify, or reverse engineer Apple Software. This 
License does not grant you a license to use Apple’s name, trademarks, service marks, 
or logos. Except as expressly stated in this License, no other rights or licenses, express 
or implied, are granted by Apple herein, including but not limited to any patent rights that 
may be infringed by your derivative works or by other works in which the Apple Software 
may be incorporated. Apple may terminate this license without cause upon 30 days prior 
written notice.
The Apple Software is provided by Apple on an "AS IS" basis. APPLE MAKES NO 
WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION THE 
IMPLIED WARRANTIES OF NON-INFRINGEMENT, MERCHANTABILITY, AND 
FITNESS FOR A PARTICULAR PURPOSE, REGARDING THE APPLE SOFTWARE 
OR ITS USE AND OPERATION ALONE OR IN COMBINATION WITH YOUR 
PRODUCTS.  
 
IN NO EVENT SHALL APPLE BE LIABLE FOR ANY SPECIAL, INDIRECT, 
INCIDENTAL, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED 
TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, 
DATA, OR PROFITS; OR BUSINESS INTERRUPTION) ARISING IN ANY WAY OUT 
OF THE USE, REPRODUCTION, MODIFICATION, AND/OR DISTRIBUTION OF THE 
APPLE SOFTWARE, HOWEVER CAUSED AND WHETHER UNDER THEORY OF 
CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, OR 
OTHERWISE, EVEN IF APPLE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH 
DAMAGE.
EA1718
08/03/2022
Copyright (C) 2022 Apple Inc. All Rights Reserved.
*/
if (!customElements.get('aufbau-apple-channel')) {
  customElements.define('aufbau-apple-channel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const template = this.querySelector('template');
      const root = this.shadowRoot || this.attachShadow({ mode: 'open' });
      if (template) {
        root.appendChild(template.content.cloneNode(true));
        template.remove();
      }
      this.initialized = true;
      const selects = [...root.querySelectorAll('.gallery-select')];
      const panels = [...root.querySelectorAll('[data-gallery-position]')];
      const update = (source) => {
        const option = source.selectedOptions[0];
        if (!option) return;
        const group = source.dataset.groupId;
        const position = option.dataset.optionId;
        selects.filter(select => select.dataset.groupId === group).forEach(select => {
          select.value = source.value;
          select.setAttribute('aria-controls', `${select.id}-${position}`);
        });
        panels.filter(panel => panel.dataset.galleryGroupId === group).forEach(panel => {
          const active = panel.dataset.galleryPosition === position;
          panel.dataset.activeContent = String(active);
          panel.setAttribute('aria-hidden', String(!active));
        });
      };
      selects.forEach(select => {
        select.value = 'iPhone 15 Pro';
        select.addEventListener('change', () => update(select));
      });
      if (selects.length) update(selects[0]);
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = link.hasAttribute('data-aufbau-buy')
          ? document.getElementById('MainContent')
          : root.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        const focusTarget = link.hasAttribute('data-aufbau-buy') ? target.querySelector('h1') : target;
        if (focusTarget) {
          if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aufbau-product-finder"] && !Shopify.designMode) return;
  try {
    
class AufbauFinderTree {
  constructor(products,models={}) {
    this.products=products.filter(p=>Number.isFinite(p.price)&&p.price>0);this.models=models;this.reset();
  }
  reset(){this.answers={};this.history=[];this.automatic=new Set();this.field=this.products.length?'recipient':'requirements';this.blocked=this.products.length?null:'catalog';}
  order(){return ['recipient','kind','family','model','connector','phone','interest','budget'];}
  prefix(field){const order=this.order();return Object.fromEntries(order.slice(0,order.indexOf(field)).filter(k=>this.answers[k]!==undefined).map(k=>[k,this.answers[k]]));}
  candidates(a=this.answers){
    const model=this.models[a.model];
    return this.products.filter(p=>{
      if(a.kind&&a.kind!=='any'&&a.kind!==p.kind)return false;
      if(a.family==='unknown'){
        if(p.kind==='device'&&p.families.includes('watch'))return false;
        if(p.kind==='accessory'&&!p.independent)return false;
      }else if(a.family&&!p.families.includes(a.family))return false;
      if(a.phone==='no'&&p.kind==='device'&&p.families.includes('watch'))return false;
      const fitted=p.models||[];
      if(p.requiresModel&&!fitted.length)return false;
      if(fitted.length&&(a.family==='unknown'||a.model==='unknown'||(a.model&& !fitted.includes(a.model))))return false;
      const requirement=(p.requirements||{})[a.family];
      if(a.model!==undefined&&['magsafe','wireless','notebook'].includes(requirement)&&!model?.[requirement])return false;
      if(['usb_c','lightning'].includes(requirement)){
        const port=model?.connector||a.connector;
        if(port!==undefined&&port!==requirement)return false;
      }
      const needsPort=p.connector&&p.connector!=='none'&&(!p.connectorFamily||p.connectorFamily==='all'||p.connectorFamily===a.family);
      if(needsPort&&a.connector!==undefined&&p.connector!==a.connector)return false;
      if((needsPort||requirement)&&a.family==='unknown')return false;
      if(a.interest&&!p.interests.includes(a.interest))return false;
      return !a.budget||a.budget==='any'||p.price<=Number(a.budget)*100;
    });
  }
  plan(){
    const fields=['recipient','kind','family'],{kind,family}=this.answers,pool=this.candidates({kind,family});
    if(kind&&kind!=='device'&&family&&family!=='unknown'){
      if(pool.some(p=>(p.models||[]).length||['magsafe','wireless','notebook'].includes((p.requirements||{})[family])))fields.push('model');
      if(pool.some(p=>['usb_c','lightning'].includes((p.requirements||{})[family])||(p.connector&&p.connector!=='none'&&(!p.connectorFamily||p.connectorFamily==='all'||p.connectorFamily===family))))fields.push('connector');
    }
    if(kind&&kind!=='accessory'&&family==='watch')fields.push('phone');
    return [...fields,'interest','budget'];
  }
  budgets(pool){
    if(!pool.length)return [];
    const prices=pool.map(p=>p.price),maximum=Math.max(...prices)/100,limits=[25000,50000,100000,150000,300000,500000,700000,1000000,1500000,2000000,2500000,3500000,5000000];
    if(maximum>limits.at(-1))limits.push(Math.ceil(maximum/500000)*500000);
    const distinct=[];let count=0;
    for(const cap of limits){const eligible=prices.filter(p=>p<=cap*100).length;if(eligible>count){distinct.push(String(cap));count=eligible;}if(count===prices.length)break;}
    return [...(distinct.length>3?[distinct[0],distinct[Math.floor((distinct.length-1)/2)],distinct.at(-1)]:distinct),'any'];
  }
  choices(field=this.field){
    if(field==='recipient')return this.products.length?['self','gift']:[];
    if(field==='phone')return ['yes','no'];
    const prefix=this.prefix(field);
    if(field==='model')return [...Object.values(this.models).filter(m=>m.family===prefix.family&&this.candidates({...prefix,model:m.key,connector:m.connector}).length).map(m=>m.key),...(this.candidates({...prefix,model:'unknown'}).length?['unknown']:[])];
    if(field==='connector')return prefix.family==='mac'?['usb_c','other','unknown']:['usb_c','lightning','unknown'];
    if(field==='budget')return this.budgets(this.candidates(prefix));
    const domains={kind:['device','accessory','any'],family:['iphone','mac','ipad','watch','airpods','unknown'],interest:prefix.kind==='accessory'?['charge','desk','audio','care','portable']:['work','create','audio','active','daily']};
    return (domains[field]||[]).filter(value=>{
      if(field==='kind'&&value==='any')return ['device','accessory'].every(kind=>this.candidates({...prefix,kind}).length);
      return this.candidates({...prefix,[field]:value}).length>0;
    });
  }
  choose(field,value){
    if(field!==this.field||!this.choices(field).includes(value))return false;
    this.answers={...this.prefix(field),[field]:value};const order=this.order();this.automatic=new Set([...this.automatic].filter(k=>order.indexOf(k)<order.indexOf(field)));this.history.push(field);this.advance();return true;
  }
  advance(){
    this.blocked=null;
    if(this.answers.kind==='any'&&!this.answers.family){this.answers.family='unknown';this.automatic.add('family');}
    const model=this.models[this.answers.model];
    if(model&&this.plan().includes('connector')){this.answers.connector=model.connector;this.automatic.add('connector');}
    if(!this.candidates().length){this.blocked=this.answers.phone==='no'?'phone':(this.answers.connector?'connector':'catalog');this.field='requirements';return;}
    let next=this.plan().find(f=>this.answers[f]===undefined);
    while(next==='interest'&&this.choices(next).length===1){this.answers[next]=this.choices(next)[0];this.automatic.add(next);next=this.plan().find(f=>this.answers[f]===undefined);}
    if(next&&this.choices(next).length===0){this.blocked='catalog';this.field='requirements';return;}
    this.field=next||'results';
  }
  back(){const previous=this.history.pop();if(previous){this.field=previous;this.blocked=null;}}
  changeFamily(){this.answers=this.prefix('family');this.history=this.history.filter(f=>['recipient','kind'].includes(f));this.automatic.clear();this.blocked=null;this.field='family';}
  results(){
    const score=p=>p.priority+(this.answers.recipient==='gift'&&p.gift?12:0)+((p.models||[]).includes(this.answers.model)?8:0);
    const pool=this.candidates().sort((a,b)=>score(b)-score(a)||a.price-b.price),selected=[],types=new Set();
    for(const p of pool){const type=p.kind==='device'?p.families.join(','):(p.type||p.template?.dataset.type||p.kind);if(!types.has(type)){selected.push(p);types.add(type);}if(selected.length===3)break;}
    for(const p of pool){if(selected.length===3)break;if(!selected.includes(p))selected.push(p);}
    return selected;
  }
}

if (!customElements.get('aufbau-product-finder')) {
  customElements.define('aufbau-product-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.dialog = this.querySelector('dialog');
      this.strings = JSON.parse(this.querySelector('[data-finder-strings]').textContent);
      this.models = JSON.parse(this.querySelector('[data-finder-models]').textContent);
      this.definitions = {};
      this.querySelectorAll('[data-choice]').forEach(b => {
        this.definitions[b.dataset.field] ||= {};
        this.definitions[b.dataset.field][b.dataset.value] = {label:b.querySelector('[data-choice-label]').textContent,description:b.querySelector('small')?.textContent || ''};
      });
      this.tree = new AufbauFinderTree([...this.querySelectorAll('template[data-product]')].map(t => ({
        template:t, models:(t.dataset.models || '').split(',').filter(Boolean), requirements:Object.fromEntries((t.dataset.requirements || '').split(',').filter(Boolean).map(r=>r.split(':'))), type:t.dataset.type, price:Number(t.dataset.price), priority:Number(t.dataset.priority),kind:t.dataset.kind,
        families:t.dataset.families.split(',').filter(Boolean),interests:t.dataset.interests.split(',').filter(Boolean),
        independent:t.dataset.independent === 'true',gift:t.dataset.gift === 'true',connector:t.dataset.connector || 'none',
        connectorFamily:t.dataset.connectorFamily || 'all',requiresModel:t.dataset.requiresModel === 'true'
      })),this.models);
      document.addEventListener('click',event => {
        const trigger = event.target.closest('[data-aufbau-finder-open]');
        if (!trigger || trigger.getAttribute('href') !== '#'+this.id) return;
        event.preventDefault(); this.dialog.showModal(); this.render();
      },options);
      this.addEventListener('click',event => {
        const choice = event.target.closest('[data-choice]');
        if (choice && this.tree.choose(choice.dataset.field,choice.dataset.value)) this.render();
        if (event.target.closest('[data-finder-back]')) { this.tree.back(); this.render(); }
        if (event.target.closest('[data-finder-reset]')) { this.tree.reset(); this.render(); }
        if (event.target.closest('[data-finder-change-family]')) { this.tree.changeFamily(); this.render(); }
        if (event.target.closest('[data-finder-close]')) this.dialog.close();
      },options);
      this.dialog.addEventListener('click',event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      },options);
      this.dialog.addEventListener('close',() => document.querySelector('[data-aufbau-finder-open][href="#'+this.id+'"]')?.focus(),options);
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang.startsWith('es') ? 'es-CL' : 'en-US',{style:'currency',currency:this.dataset.currency || 'CLP',maximumFractionDigits:0}).format(cents/100); }
    definition(field,value) {
      const {kind} = this.tree.answers;
      if (field === 'model') return {label:value === 'unknown' ? this.strings.modelUnknown : this.models[value].label, description:value === 'unknown' ? '' : this.strings.modelKnownDescription};
      if (field === 'budget') return {label:value === 'any' ? this.strings.budgetAny : this.strings.budgetLabel.replace('[amount]',this.money(Number(value)*100)),description:''};
      if (field === 'family' && value === 'unknown') return {label:kind === 'device' ? this.strings.noPreference : (kind === 'any' ? this.strings.anyFamily : this.strings.dontKnow),description:''};
      if (field === 'interest' && kind === 'accessory') return this.strings.accessoryInterests[value];
      if (field === 'interest' && kind === 'device') {
        const key=this.tree.answers.family === 'iphone' && value === 'create' ? 'iphoneCreate' : (value === 'daily' ? 'deviceDaily' : (value === 'audio' ? 'deviceAudio' : null));
        if (key) return this.strings.deviceInterests[key];
      }
      return this.definitions[field]?.[value] || {label:value,description:''};
    }
    render() {
      const {field,answers} = this.tree;
      this.querySelectorAll('[data-panel]').forEach(p => { p.hidden = p.dataset.panel !== field; });
      const plan = this.tree.plan().filter(f => !this.tree.automatic.has(f)), index = plan.indexOf(field), done = ['results','requirements'].includes(field);
      this.querySelector('[data-finder-progress]').textContent = done ? this.strings.resultsProgress : this.strings.progress.replace('[step]',index+1).replace('[total]',plan.length);
      this.querySelector('[data-finder-dots]').replaceChildren(...plan.map((f,i) => {const d=document.createElement('span');d.className=done || i<index ? 'is-complete' : (i===index ? 'is-current' : '');return d;}));
      this.querySelector('[data-finder-back]').hidden = !this.tree.history.length;
      this.querySelector('.ab-finder-hint').hidden = done;
      this.querySelector('[data-interest-question]').textContent = answers.kind === 'accessory' ? this.strings.accessoryQuestion : (answers.recipient === 'self' ? this.strings.selfInterestQuestion : this.strings.giftInterestQuestion);
      this.querySelector('[data-family-question]').textContent = answers.kind === 'device' ? this.strings.deviceQuestion : (answers.kind === 'any' ? this.strings.anyFamilyQuestion : (answers.recipient === 'self' ? this.strings.selfFamilyQuestion : this.strings.familyQuestion));
      this.querySelector('[data-family-description]').textContent = answers.kind === 'device' ? this.strings.deviceFamilyDescription : (answers.kind === 'any' ? this.strings.anyFamilyDescription : this.strings.accessoryFamilyDescription);
      if (field === 'results') this.recommend();
      else if (field === 'requirements') {
        this.querySelector('[data-requirement-title]').textContent = this.strings.requirements[this.tree.blocked].title;
        this.querySelector('[data-requirement-description]').textContent = this.strings.requirements[this.tree.blocked].description;
        this.querySelector('[data-finder-change-family]').hidden = !answers.kind;
      } else {
        const panel = this.querySelector('[data-panel="'+field+'"]');
        panel.querySelector('.ab-finder-choices').replaceChildren(...this.tree.choices().map(value => {
          const data = this.definition(field,value), button = document.createElement('button');
          button.type='button';button.className='ab-finder-choice';button.dataset.choice='';button.dataset.field=field;button.dataset.value=value;
          button.setAttribute('aria-pressed',String(answers[field]===value));
          const label=document.createElement('span');label.dataset.choiceLabel='';label.textContent=data.label;button.append(label);
          if (data.description) {const desc=document.createElement('small');desc.textContent=data.description;button.append(desc);}
          const arrow=document.createElement('span');arrow.className='ab-finder-choice-arrow';arrow.setAttribute('aria-hidden','true');arrow.textContent='↗';button.append(arrow);
          return button;
        }));
        if (field === 'budget') this.querySelector('[data-budget-description]').textContent = this.strings.budgetDescription.replace('[amount]',this.money(Math.min(...this.tree.candidates(this.tree.prefix('budget')).map(p=>p.price))));
      }
      this.querySelector('[data-panel="'+field+'"] h2').focus({preventScroll:true});
      this.querySelector('.ab-finder-body').scrollTop=0;
    }
    recommend() {
      const matches=this.tree.results();
      const model=this.models[this.tree.answers.model], catalogLink=this.querySelector('[data-finder-catalog-link]');
      catalogLink.hidden=!(this.tree.answers.kind==='accessory' && model);
      if(model) catalogLink.href=model.url;
      this.querySelector('[data-finder-results]').replaceChildren(...matches.map(p=>p.template.content.cloneNode(true)));
      this.querySelector('[data-finder-empty]').hidden=matches.length>0;
      this.querySelector('[data-finder-result-note]').hidden=!matches.length;
      this.querySelector('[data-results-title]').textContent=matches.length ? (this.tree.answers.recipient==='gift' ? this.strings.giftResults : this.strings.selfResults) : this.strings.emptyTitle;
      this.querySelector('[data-finder-summary]').textContent=this.tree.plan().filter(f=>this.tree.answers[f]!==undefined).map(f=>this.definition(f,this.tree.answers[f]).label).join(' · ');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aufbau-shelf"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aufbau-shelf')) {
  customElements.define('aufbau-shelf', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.ab-shelf-track');
      const controls = this.querySelector('.ab-shelf-controls');
      if (!track || !controls) return;
      const buttons = [...controls.querySelectorAll('button')];
      const update = () => {
        const overflowing = track.scrollWidth > track.clientWidth + 4;
        controls.hidden = !overflowing;
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('.ab-shelf-card');
        const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap) : track.clientWidth;
        track.scrollBy({ left: distance * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, {signal}));
      track.addEventListener('scroll', update, {signal, passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
